import React, { Fragment } from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { getFormattedNumber } from "../utils";

const COLORS = {
  active: "green",
  pending: "blue",
  sold: "black",
  expired: "red",
  withdrawn: "red"
};

const Column = styled.span`
  color: "#333";
  font-size: 0.875;
  font-weight: 600;
`;

const StatusColumn = styled(Column)`
  color: ${(props) => props?.color ?? "#333333"};
  text-transform: uppercase;
`;

const Container = styled.section`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 0.75rem 1rem;
  justify-content: space-between;
  background-color: #FAFAFA;
`;

const Separator = styled.span`
  width: 1px;
  background-color: #c4c4c4;
  align-self: stretch;
  &:last-of-type {
    display: none;
  }
`;

const VALUE_RENDERER = {
  number: (value) => getFormattedNumber(value),
  default: (value) => value,
};

const RoomsDetails = ({ listing = {} }) => {
  const { MlsStatus, MlsStatusDisplay } = listing;
  const statusColor = COLORS[MlsStatus.toString().toLowerCase()];
  const sectionRoom = listing?.ReportFields?.Sections?.find(
    (section) => section.Title === "Rooms_CARD"
  );
  const allColumns = [
    ...(sectionRoom?.Column1 ?? []),
    ...(sectionRoom?.Column2 ?? []),
    ...(sectionRoom?.Column3 ?? []),
  ];

  const renderColumn = useCallback((column) => {
    const { Id, PostLabel, PreLabel, Type, Value } = column;
    const renderer = VALUE_RENDERER[Type] ?? VALUE_RENDERER.default;
    const value = renderer(Value);
    return (
      <Fragment key={Id}>
        <Column>
          {PreLabel} {value} {PostLabel}
        </Column>
        <Separator />
      </Fragment>
    );
  }, []);
  if (!allColumns?.length) return null;

  return (
    <Container>
      <StatusColumn color={statusColor} title={MlsStatus}>{MlsStatusDisplay}</StatusColumn>
      <Separator />
      {allColumns.map(renderColumn)}
    </Container>
  );
};

export default RoomsDetails;
